import { createAppStore } from '@mobileStore/createAppStore';
import { FeatureFlags } from '@constants/featureFlags';
import { createSignal } from 'solid-js';

import { GetFeatureFlags } from './service';
import { Feature, FeatureFlagState } from './types';

const [featureFlagStore, setFeatureFlagStore] =
  createAppStore<FeatureFlagState>(
    {
      isLoading: false,
      isError: false,
      loaded: false,
      errorMessage: undefined,
      flags: [] as Feature[],
    },
    'mobileFeatureFlagStore',
  );

const [enabledFlags, setEnabledFlags] = createSignal(new Set<string>());

const initializeFeatureFlags = async () => {
  setFeatureFlagStore('isLoading', true);
  setFeatureFlagStore('isError', false);
  setFeatureFlagStore('errorMessage', undefined);

  try {
    const flags = await GetFeatureFlags();

    const set = new Set<string>();
    for (const f of flags) {
      if (f.value.toLowerCase() === 'enabled') {
        set.add(f.id.toLowerCase());
      }
    }
    setEnabledFlags(set);

    setFeatureFlagStore('flags', flags);
    setFeatureFlagStore('isLoading', false);
    setFeatureFlagStore('isError', false);
    setFeatureFlagStore('errorMessage', undefined);
    setFeatureFlagStore('loaded', true);
  } catch (error) {
    setEnabledFlags(new Set<string>());
    setFeatureFlagStore('flags', [] as Feature[]);
    setFeatureFlagStore('isLoading', false);
    setFeatureFlagStore('isError', true);
    setFeatureFlagStore('loaded', true);
    setFeatureFlagStore('errorMessage', (error as Error).message);
  }
};

const isFeatureFlagEnabled = (value: FeatureFlags): (() => boolean) => {
  const key = value.toLowerCase();
  return () => enabledFlags().has(key);
};

export { featureFlagStore, initializeFeatureFlags, isFeatureFlagEnabled };
